import React from "react";
import { CheckCircle2, AlertTriangle, OctagonAlert, Loader2 } from "lucide-react";

const STATE = {
  green: { c: "#22E0A1", glow: "rgba(34,224,161,0.35)", word: "GO NOW", Icon: CheckCircle2, pct: 0.94 },
  amber: { c: "#FFC726", glow: "rgba(255,199,38,0.35)", word: "CAUTION", Icon: AlertTriangle, pct: 0.62 },
  red:   { c: "#FF5C7A", glow: "rgba(255,92,122,0.38)", word: "WAIT", Icon: OctagonAlert, pct: 0.34 },
};

const R = 84;
const CIRC = 2 * Math.PI * R;

const Dial = ({ level = "amber", headline, sub, eta, loading }) => {
  const s = STATE[level] || STATE.amber;
  const Icon = s.Icon;
  const dash = CIRC * s.pct;

  return (
    <div className="flex flex-col items-center text-center" data-testid="leave-now-dial">
      <div className="relative go-dial-pulse" style={{ width: 236, height: 236 }}>
        <div
          className="absolute inset-2 rounded-full"
          style={{ background: `radial-gradient(circle at 50% 42%, ${s.glow}, transparent 68%)`, boxShadow: `0 0 60px ${s.glow}` }}
        />
        <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full -rotate-90">
          <circle cx="100" cy="100" r={R} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="15" />
          <circle
            cx="100" cy="100" r={R} fill="none" stroke={s.c} strokeWidth="15" strokeLinecap="round"
            strokeDasharray={`${dash} ${CIRC}`}
            style={{ transition: "stroke-dasharray 0.8s cubic-bezier(0.22,1,0.36,1), stroke 0.4s ease", filter: `drop-shadow(0 0 8px ${s.glow})` }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          {loading ? (
            <Loader2 className="animate-spin" size={40} color={s.c} strokeWidth={2.5} />
          ) : (
            <>
              <Icon size={44} color={s.c} strokeWidth={2.3} data-testid="dial-status" />
              <div className="font-head mt-1 text-2xl font-extrabold" style={{ color: s.c }}>{s.word}</div>
              {eta && (
                <div className="mt-0.5 text-xs font-semibold text-[#8194B2]" data-testid="dial-eta">
                  ETA {eta}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="mt-5 px-4">
        <h2 className="font-head text-xl font-bold text-white" data-testid="dial-headline">
          {loading ? "Reading the roads…" : headline}
        </h2>
        {sub && !loading && <p className="mt-1.5 text-sm leading-relaxed text-[#8194B2]">{sub}</p>}
      </div>
    </div>
  );
};

export default Dial;
